export default __webpack_public_path__ + "static/media/signup.12ac0919.png";